import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    flexDirectionRow: {
        flexDirection: 'row',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
    },
    image: {
        width: 120,
        height: 120,
        alignSelf: 'center',
    },
    title: {
        fontSize: 22,
        fontWeight: 'bold',
        textAlign: 'center',
        lineHeight: 26,
        color: theme.colors.textPrimary,
    },
    description: {
        fontSize: 16,
        fontWeight: 'normal',
        textAlign: 'center',
        color: theme.colors.textSecondary,
    },
    monthlyButtonActive: {
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 8,
        marginHorizontal: 12,
        marginBottom: 16,
    },
    monthlyButtonInactive: {
        backgroundColor: theme.colors.disabled,
        padding: 10,
        borderRadius: 8,
        marginHorizontal: 12,
        marginBottom: 16,
    },
    monthlyBorderButton: {
        backgroundColor: 'white',
        borderColor: theme.colors.colorPrimary,
        borderWidth: 0.5,
        padding: 10,
        borderRadius: 8,
        marginHorizontal: 12,
        marginBottom: 8,
    },
    monthlyBorderButtonText: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.darkGray,
        textAlign: 'center',
    },
    monthlyButtonTextActive: {
        fontSize: 16,
        fontWeight: 'bold',
        color: 'white',
        textAlign: 'center',
    },
    monthlyButtonTextInactive: {
        fontSize: 16,
        color: theme.colors.darkGray,
        textAlign: 'center',
    },
    weekButtonActive: {
        backgroundColor: 'transparent',
        padding: 10,
        borderRadius: 8,
        marginBottom: 8,
        marginHorizontal: 12,
    },
    weekButtonInactive: {
        backgroundColor: 'transparent',
        padding: 7,
        borderRadius: 8,
        marginBottom: 8,
        borderColor: 'transparent',
        borderWidth: 1,
        marginHorizontal: 12,
    },
    weekButtonPending: {
        backgroundColor: 'white',
        padding: 7,
        borderRadius: 8,
        marginBottom: 8,
        borderColor: 'transparent',
        borderWidth: 1,
        marginHorizontal: 12,
    },
    weekButtonTextActive: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
        textAlign: 'center',
    },
    weekButtonTextInactive: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.lightGray,
        textAlign: 'center',
    },
    weekButtonTextPending: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
        textAlign: 'center',
    },
    justifyCenter: {
        alignSelf: 'center',
    },
    paddingHorizontal: {
        paddingHorizontal: 12,
    },
    marginLeft: {
        marginLeft: 8,
    },
    spacer1: {
        height: 4,
    },
    spacer2: {
        height: 12,
    },
    spacer3: {
        height: 20,
    },
})

export default styles
